module.exports = __webpack_public_path__ + "img/pro_one_10.000c4c9e.jpg";